import axios from 'axios';
import { BookingAvailabilityResponseDto, CreateBookingAvailabilityDto, MessageResponseDto, UpdateBookingAvailabilityDto } from '../types/booking';
import { SERVICES_API_BASE_URL } from './apiConfig';

const API_BASE = `${SERVICES_API_BASE_URL}/api/BookingAvailability`;

const api = axios.create();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const availabilityApi = {
  getAvailability: () => api.get<BookingAvailabilityResponseDto[]>(API_BASE),
  getSchedule: (availabilityId: string) => api.get<BookingAvailabilityResponseDto>(`${API_BASE}/${availabilityId}`),
  createSchedule: (data: CreateBookingAvailabilityDto) => api.post<BookingAvailabilityResponseDto>(API_BASE, data),
  updateSchedule: (availabilityId: string, data: UpdateBookingAvailabilityDto) => api.put<BookingAvailabilityResponseDto>(`${API_BASE}/${availabilityId}`, data),
  deleteSchedule: (availabilityId: string) => api.delete<MessageResponseDto>(`${API_BASE}/${availabilityId}`),
};

